import { Component, Vue, Prop } from 'vue-property-decorator';
import WithRender from './Replay.html';
import config from "@/settings/config.js";
import { ReplayDto } from '@/Dtos/ReplayDto';
import Modal from "@/components/Modal.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import _axios from '@/services/axios';

@WithRender
@Component({
  components: {
    Loading,
    Modal
  }
})
export default class Replay extends Vue {
  replayDto: ReplayDto[] = {} as ReplayDto[];
  modalState = false;
  isLoading = false;

  mounted() {
    this.getToReplay();
  }

  confirmAction(value: ReplayDto) {
    this.isLoading = true;
    let dto = { paymentId: value.paymentDetailId }
    _axios.post(config.gateway + "payment/Transactions/RefreshTransactions", dto).then(response => {
      console.log(response.data);
    }).catch(err => { console.error(err); })
      .finally(() => {
        this.isLoading = false;
        this.getToReplay();
      });
  }

  getToReplay(): void {
    _axios.get(config.gateway + "payment/Transactions/UnsuccessfulTransactions?userId=3e36c57f-9279-4d0e-b917-87742f10ff60").then(response => {
      this.mapOutTransactions(response.data);
    }).catch(err => {
      console.error(err);
    });
  }

  private mapOutTransactions(value: ReplayDto[]) {
    this.replayDto = value;
  }
}
